const dev = 'https://newadmin.ptestudy.com/' // 正式
const prod = 'https://newadmin.ptestudy.com/' // 测试

// const dev = 'http://localhost:8088/' // 正式
// const prod = 'http://localhost:8088/' // 测试

const base = prod

export default base;


// WEBPACK FOOTER //
// ./src/api/base.js